<template>
  <div id="logo">
    <img src="../assets/MORTOR_LOGO.png" alt="MORTOR">
  </div>
</template>

<script>
export default {
  name: 'Logo'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #logo img{
    width: 70vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/Logo.vue